import { VALIDATION } from 'constant';
import { _t } from 'utils';

export const createForm = {
  fields: [
    {
      name: 'name',
      type: 'text',
      title: _t('Name'),
    },
    {
      name: 'certificate',
      type: 'file-reader',
      title: 'Certificate (PEM Format)',
    },
    {
      name: 'certificateChain',
      type: 'file-reader',
      title: 'Certificate Chain (PEM Format)',
    },
    {
      name: 'privateKey',
      type: 'file-reader',
      title: 'Private Key (PEM Format)',
    },
  ],
  validations: [
    {
      name: 'name',
      type: VALIDATION.REQUIRED,
    },
    {
      name: 'certificate',
      type: VALIDATION.REQUIRED,
    },
    {
      name: 'privateKey',
      type: VALIDATION.REQUIRED,
    },
  ],
  isCancel: false,
};
